import React, { Component, Fragment } from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { Checkbox, Tooltip, Divider, ColorPicker } from 'antd';
import '../index.css';

const CheckboxGroup = Checkbox.Group;

class WaveformSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resultShow: true,
      powerGroups: {},
    }
  }

  componentDidMount = () => {
    this.initExpandedGroup()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.compInfo.length !== this.props.compInfo.length) {
      this.initExpandedGroup()
    }
  }

  initExpandedGroup = () => {
    const { compInfo } = this.props
    const powerGroups = compInfo.reduce((acc, curve) => {
      const { power } = curve;
      if (!acc[power]) {
        acc[power] = {
          expanded: true,
          checkedAll: false,
          indeterminate: false,
        };
      }
      return acc;
    }, {});

    this.setState({
      powerGroups,
    });
  }

  changeResultShow = () => {
    this.setState((prev => ({
      resultShow: !prev.resultShow
    })));
  }

  stopPropagation = (e) => {
    e && e.stopPropagation()
    e && e.preventDefault()
  }

  changeSelectedKeys = (keys, power) => {
    const { compInfo, selectedKeys } = this.props;
    const { powerGroups } = this.state
    const groupItems = compInfo.filter(group => group.power === power) || [];
    const groupNames = groupItems.map(item => item.name);
    const newSelectedKeys = [
      ...selectedKeys.filter(name => !groupNames.includes(name)),
      ...keys
    ];
    this.props.changeSelectedKeys(newSelectedKeys);
    const selectedInGroup = newSelectedKeys.filter(name => groupNames.includes(name));
    const checkedAll = selectedInGroup.length === groupNames.length;
    const indeterminate = selectedInGroup.length > 0 && selectedInGroup.length < groupNames.length;
    this.setState({
      powerGroups: {
        ...powerGroups,
        [power]: {
          ...powerGroups[power],
          checkedAll,
          indeterminate,
        },
      },
    });
  }

  handleGroupToggle = (power) => {
    const { powerGroups } = this.state;
    this.setState({
      powerGroups: {
        ...powerGroups,
        [power]: {
          ...powerGroups[power],
          expanded: !powerGroups[power].expanded,
        },
      },
    });
  }

  changeGroupSelectAll = (power, e) => {
    const { compInfo, selectedKeys } = this.props;
    const { powerGroups } = this.state
    const groupItems = compInfo.filter(item => item.power === power);
    const groupNames = groupItems.map(item => item.name);
    const checkedAll = e.target.checked;
    let newSelectedKeys = checkedAll ? [...selectedKeys, ...groupNames] : selectedKeys.filter(name => !groupNames.includes(name));
    const selectedCount = groupNames.filter(name => newSelectedKeys.includes(name)).length;
    const indeterminate = selectedCount > 0 && selectedCount < groupNames.length;
    this.setState({
      powerGroups: {
        ...powerGroups,
        [power]: {
          ...powerGroups[power],
          checkedAll,
          indeterminate,
        }
      }
    }, () => {
      this.props.changeSelectedKeys(newSelectedKeys);
    });
  };

  render() {
    const { resultShow, powerGroups } = this.state;
    const { compInfo = [], colorChange, selectedKeys = [], powerDisc = [] } = this.props
    const Icon = resultShow ? DownOutlined : RightOutlined;
    let groupedCompInfo = [];
    for (let i = 0; i < compInfo.length; i++) {
      const { power, powerIndex } = compInfo[i];
      let group = groupedCompInfo.find(item => item.powerIndex === powerIndex);
      if (!group) {
        group = { powerIndex: powerIndex, curves: [], rowName: powerDisc[power] || '', power };
        groupedCompInfo.push(group);
      }
      group.curves.push({ ...compInfo[i] });
    }
    groupedCompInfo.sort((a, b) =>
      (!a.rowName) - (!b.rowName) || a.powerIndex - b.powerIndex
    );
    return (
      <div className='sparameter-channel-result-content'>
        <Divider
          orientation="left"
          className={'sparameter-channel-result-margin'}
        >
          <div className='result-import-title'>
            <span onClick={this.changeResultShow}>
              <Icon className="sparameter-title-expand-icon" />
              <span className='sparameter-result-menu-title'>Current Result</span>
            </span>
          </div>
        </Divider>
        {resultShow && <div className='sparameter-result-file-content'>
          {groupedCompInfo.map(group => {
            const { curves, rowName, power } = group
            const groupExpanded = powerGroups[power] && powerGroups[power].expanded;
            const checkedAll = powerGroups[power] && powerGroups[power].checkedAll;
            const indeterminate = powerGroups[power] && powerGroups[power].indeterminate;
            const groupSelectedKeys = selectedKeys.filter((key) => curves.some(item => item.name === key));
            return (
              <div key={power}>
                {rowName ? <div className="sparameter-result-group-header">
                  <Checkbox
                    checked={checkedAll}
                    indeterminate={indeterminate}
                    onChange={(e) => this.changeGroupSelectAll(power, e)}
                    className='sparameter-result-check-all'
                  />
                  <div onClick={() => this.handleGroupToggle(power)} className='sparameter-channel-display-row'>
                    {groupExpanded ? (
                      <DownOutlined className="sparameter-file-expand-icon" />
                    ) : (
                      <RightOutlined className="sparameter-file-expand-icon" />
                    )}
                    <span>{rowName}</span>
                  </div>
                </div> : null}
                <CheckboxGroup value={groupSelectedKeys} onChange={(keys) => this.changeSelectedKeys(keys, power)}>
                  {groupExpanded && curves.map((item) => (
                    <Checkbox value={item.name} key={item.name} className="sparameter-result-checkbox-group" onClick={(e) => e.stopPropagation()}>
                      <span className="sparameter-result-checkbox-group-name">
                        <ColorPicker
                          value={item.color}
                          className="aurora-color-picker-small"
                          onChange={(value) => colorChange(value, item.curveIndex)}
                          size="small"
                          onClick={(e) => this.stopPropagation(e)}
                        />
                        <label className="sparameter-result-label">
                          <Tooltip title={item.title} placement="top" classNames={{ root: 'aurora-tooltip' }}>
                            <span className="waveform-comp-name">{item.title}</span>
                          </Tooltip>
                        </label>
                        <span style={{ color: item.color }} className="result-curve-current">
                          {item.current}
                        </span>
                      </span>
                    </Checkbox>
                  ))}
                </CheckboxGroup>
              </div>
            );
          })}
        </div>
        }
      </div>
    );
  }
}

export default WaveformSelection;